import React, { useState, useEffect } from "react";
import {
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,        // <--- add this
  DialogContentText,    // <--- add this
  DialogActions,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import "./SiteTeamMembers.css";
import CreateSiteMember from "./CreateSiteMember";
import EditSiteTeamMember from "./EditSiteTeamMember";
import apiService from "../../utils/apiservice";


const SiteTeamMembers = () => {
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState("");
  const [contacts, setContacts] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [contactToDelete, setContactToDelete] = useState(null);
  const [createOpen, setCreateOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [contactToEdit, setContactToEdit] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");

  const API_URL = process.env.REACT_APP_API_DJANGO_URL;
  const token = localStorage.getItem("accessToken");
  // const customerId = localStorage.getItem("customer_id");



  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await apiService.get(
          `${API_URL}/api/get_customers/`,
          {
            data: {},
          }
        );

        const customerData = response.data || [];
        setCustomers(customerData);

        // auto select first customer
        if (customerData.length > 0) {
          setSelectedCustomer(customerData[0].tb_customer_id);
        }
      } catch (error) {
        console.error("Error fetching customers:", error);
        toast.error("Failed to fetch customers");
      }
    };

    fetchCustomers();
  }, []);


  useEffect(() => {
    const fetchSites = async () => {
      if (!selectedCustomer) return;
      try {
        // const response = await axios.get(
        //   `${API_URL}/api/get_customer_sites/${customerId}/`,
        //   {
        //     headers: {
        //       Authorization: `Bearer ${token}`,
        //       Accept: "application/json",
        //     },
        //     data: {},
        //   }
        // );

        const response = await apiService.get(
          `${API_URL}/api/get_customer_sites/${selectedCustomer}/`,
          {

            data: {},
          }
        );


        const siteData = response.data.data || [];
        setSites(siteData);
        if (siteData.length > 0) setSelectedSite(siteData[0].site_id);
      } catch (error) {
        console.error("Error fetching sites:", error);
        toast.error("Failed to fetch sites");
      }
    };
    fetchSites();
  }, [selectedCustomer, token]);

  useEffect(() => {
    const fetchContacts = async () => {
      if (!selectedSite) return;
      try {
        // const res = await axios.get(
        //   `${API_URL}/api/get_site_alert_contacts/${selectedSite}/`,
        //   {
        //     headers: {
        //       Authorization: `Bearer ${token}`,
        //       Accept: "application/json",
        //     },
        //     data: {},
        //   }
        // );

        const res = await apiService.get(
          `${API_URL}/api/get_site_alert_contacts/${selectedSite}/`,
          {

            data: {},
          }
        );
        setContacts(res.data.contacts || []);
      } catch (error) {
        console.error("Error fetching contacts:", error);
        toast.error("Failed to fetch contacts");
      }
    };
    fetchContacts();
  }, [selectedSite, token]);

  const handleDeleteClick = (contact) => {
    setContactToDelete(contact);
    setDeleteOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!contactToDelete) return;

    try {
      const response = await axios.delete(
        `${API_URL}/api/delete_site_alert_contact/${contactToDelete.id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          data: {},
        }
      );

      console.log("DELETE RESPONSE:", response);

      // ✅ safer check
      if (response?.data?.message) {
        toast.success(response.data.message);

        setContacts((prev) =>
          prev.filter((c) => c.id !== contactToDelete.id)
        );
      } else {
        toast.error("Delete failed");
      }
    } catch (error) {
      console.error("Error deleting contact:", error);

      // 🔥 important fix
      if (error.response) {
        toast.error(error.response.data?.error || "API Error");
      } else {
        toast.error("Network error");
      }
    } finally {
      setDeleteOpen(false);
      setContactToDelete(null);
    }
  };
  const handleOpenModal = () => setCreateOpen(true);
  const handleCloseModal = () => setCreateOpen(false);

  // ---------- Edit modal handlers ----------
  const handleEditClick = (contact) => {
    setContactToEdit(contact);
    setEditOpen(true);
  };
  const handleCloseEditModal = () => setEditOpen(false);

  // Add this inside your component
  const handleContactUpdated = async () => {
    if (!selectedSite) return;
    try {
      const res = await axios.get(
        `${API_URL}/api/get_site_alert_contacts/${selectedSite}/`,
        { headers: { Authorization: `Bearer ${token}`, Accept: "application/json" }, data: {}, }
      );
      setContacts(res.data.contacts || []);
    } catch (error) {
      console.error("Error fetching contacts:", error);
      toast.error("Failed to refresh contacts");
    }
  };


  return (
    <Box className="view-contacts-container">
      {/* Dropdown + Create Button */}
      <Box className="dropdown-button-row">


        <FormControl>
          <InputLabel>Select Customer</InputLabel>
          <Select
            value={selectedCustomer}
            label="Select Customer"
            onChange={(e) => {
              setSelectedCustomer(e.target.value);
              setSelectedSite(""); // reset site when customer changes
              setContacts([]); // clear contacts
            }}
          >
            {customers.length > 0 ? (
              customers.map((customer) => (
                <MenuItem
                  key={customer.tb_customer_id}
                  value={customer.tb_customer_id}
                >
                  {customer.customer_name}
                </MenuItem>
              ))
            ) : (
              <MenuItem value="" disabled>
                No Customers Found
              </MenuItem>
            )}
          </Select>
        </FormControl>
        <FormControl>
          <InputLabel>Select Site</InputLabel>
          <Select
            value={selectedSite}
            label="Select Site"
            onChange={(e) => setSelectedSite(e.target.value)}
          >
            {sites.length > 0
              ? sites.map((site) => (
                <MenuItem key={site.site_id} value={site.site_id}>
                  {site.name}
                </MenuItem>
              ))
              : (
                <MenuItem value="" disabled>No Sites Found</MenuItem>
              )}
          </Select>
        </FormControl>

        <Button
          variant="contained"
          className="create-group-btn"
          startIcon={<CreateNewFolderIcon />}
          onClick={handleOpenModal}
        >
          Create Site Member
        </Button>
      </Box>

      {/* Contacts Table */}
      <TableContainer component={Paper} className="contacts-table-wrapper">
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Sr No</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone Number</TableCell>
              <TableCell>Designation</TableCell>
              <TableCell>Email Alerts</TableCell>   {/* NEW */}
              <TableCell>SMS Alerts</TableCell>     {/* NEW */}
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contacts.length > 0
              ? contacts.map((contact, index) => (
                <TableRow key={contact.id} hover>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{contact.name}</TableCell>
                  <TableCell>{contact.email}</TableCell>
                  <TableCell>{contact.phone_no || "N/A"}</TableCell>
                  <TableCell>{contact.designation || "N/A"}</TableCell>
                  <TableCell>
                    {contact.is_email_enabled ? "Enabled" : "Disabled"}
                  </TableCell>

                  <TableCell>
                    {contact.is_sms_enabled ? "Enabled" : "Disabled"}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton color="primary" onClick={() => handleEditClick(contact)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => handleDeleteClick(contact)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
              : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    No Site Members Available
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Delete Dialog */}
      <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
        <DialogTitle>Delete Alert Contact</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure to delete {contactToDelete?.name}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteOpen(false)} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} variant="contained" color="error">
            Confirm Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* --- Modal for Create Site Member --- */}
      <Dialog open={createOpen} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <CreateSiteMember customerId={selectedCustomer}
          siteId={selectedSite} onClose={handleCloseModal} onCreated={handleContactUpdated} />
      </Dialog>

      {/* Edit Site Member Modal */}
      <Dialog open={editOpen} onClose={handleCloseEditModal} maxWidth="md" fullWidth>
        {contactToEdit && (
          <EditSiteTeamMember
            customerId={selectedCustomer}
            siteId={selectedSite}
            contact={contactToEdit}
            onClose={handleCloseEditModal}
            onUpdated={handleContactUpdated}
          />
        )}
      </Dialog>


      <ToastContainer position="top-right" autoClose={3000} />
    </Box>
  );
};

export default SiteTeamMembers;